import type { FormulaMateBlock } from './formulaMate.types';
import CodeBlock from './CodeBlock';

function TextContent({ text }: { text: string }) {
  // Only fenced blocks are interpreted. Everything else remains escaped text.
  const parts = text.split(/(```[^\n`]*\n[\s\S]*?```)/g);
  return parts.map((part, index) => {
    const code = /^```([^\n`]*)\n([\s\S]*?)```$/.exec(part);
    return code ? (
      <CodeBlock key={index} language={code[1].trim()} code={code[2]} />
    ) : (
      <p key={index} className="fm-text">
        {part}
      </p>
    );
  });
}

export default function ChatContent({
  blocks,
}: {
  blocks: FormulaMateBlock[];
}) {
  return blocks.map((block, index) => {
    switch (block.type) {
      case 'text':
        return <TextContent key={index} text={block.text} />;
      case 'code':
        return (
          <CodeBlock key={index} code={block.code} language={block.language} />
        );
      case 'section':
        return (
          <section key={index} className="fm-findings">
            <h4>{block.title}</h4>
            <ul>
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}>
                  <TextContent text={item} />
                </li>
              ))}
            </ul>
          </section>
        );
    }
  });
}
